import { useTranslation } from 'react-i18next';
import { useDataContext } from '../contexts/DataContext';
import ManufacturerIcon from '../images/manufacturer.svg';
import UdiIcon from '../images/udi.svg';

const SERIAL_NUMBER = 'AD002' + process.env.REACT_APP_BUILD_VERSION;

const Footer = () => {
    const { t } = useTranslation();
    const { softwareVersionProp, versionUDI } = useDataContext();

    return (
        <footer>
            <p className="footer-title">{t('legal.company')}</p>
            <p>
                <strong>{t('legal.focused')}</strong>
            </p>
            <div className="footer-info">
                <div className="footer-info-left">
                    <p>
                        <strong>{t('legal.description')}</strong>
                    </p>
                    <p>
                        <strong>
                            {t('legal.version')} – {softwareVersionProp}
                        </strong>
                        <br />
                        <strong>
                            {t('legal.serial')} – {SERIAL_NUMBER}
                        </strong>
                    </p>
                    <p className="udi">
                        <img
                            src={UdiIcon}
                            alt="Icon"
                            className="icon icon-udi"
                        />
                        <strong>
                            (01) {t('legal.udi')} (21) {SERIAL_NUMBER} (8012) {versionUDI}
                        </strong>
                    </p>
                    <p>{t('legal.cookies')}</p>
                </div>
                <div className="footer-info-right">
                    <div className="compliance-icons">
                        <img
                            src={process.env.PUBLIC_URL + '/conformidad-europea.png'}
                            alt="Conformidad Europea"
                            className="icon icon-conformidad-europea"
                        />
                    </div>
                    <div className="manufacturer-info">
                        <img
                            src={ManufacturerIcon}
                            alt="Icon"
                            className="icon icon-manufacturer"
                        />
                        <p className="address">
                            ADmit Therapeutics, S.L.
                            <br />
                            Carretera Laureà Miró, 408-410
                            <br />
                            08980 Sant Feliu de Llobregat
                            <br />
                            Barcelona &ndash; Spain
                            <br />
                            +34 931 088 001
                            <br />
                            mapad@admit-therapeutics.com
                        </p>
                    </div>
                </div>
            </div>
            <p className="none">{process.env.REACT_APP_BUILD_TIMESTAMP}</p>
        </footer>
    );
};

export default Footer;
